module.exports = __webpack_public_path__ + "static/img/logo_10045.a252656.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/logo/logo_10045.jpg
// module id = jjtm
// module chunks = 167